import React from 'react';
import { IconProps } from './DefaultIcon';

export function ArrowIcon(props: IconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <g clipPath="url(#clip0_2_130)">
        <path
          d="M14.9526 0V0.00799175C6.64115 0.303687 0 7.12864 0 15.504C0 19.5638 1.56638 23.264 4.12374 26.0291L15.9355 14.2173H9.67801V12.0915H17.5419H19.6677V14.2173V22.0812H17.5419V15.6159L5.66615 27.4836C8.34339 29.6814 11.7639 31 15.504 31C23.7595 31 30.5125 24.5427 30.976 16.4071H31V0H14.9526Z"
          fill="#4BD5C5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_130">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
